/**
 * #effect.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
export var EffectType;
(function (EffectType) {
    /**
     * EFFECT_REALTIME_SUB - Notify client to synchronize its realtime subscriptions
     *
     * @deprecated
     */
    EffectType[EffectType["EFFECT_REALTIME_SUB"] = 0] = "EFFECT_REALTIME_SUB";
    /**
     * EFFECT_RERENDER_UI - Trigger a re-render for apps that have visible UI
     *
     * @deprecated
     */
    EffectType[EffectType["EFFECT_RERENDER_UI"] = 1] = "EFFECT_RERENDER_UI";
    /**
     * EFFECT_RELOAD_PART - Notify the client that parts of a subreddit, post, or comment should be reloaded
     *
     * @deprecated
     */
    EffectType[EffectType["EFFECT_RELOAD_PART"] = 2] = "EFFECT_RELOAD_PART";
    /** EFFECT_SHOW_FORM - Display a user input form */
    EffectType[EffectType["EFFECT_SHOW_FORM"] = 3] = "EFFECT_SHOW_FORM";
    /** EFFECT_SHOW_TOAST - Display a transient toast message */
    EffectType[EffectType["EFFECT_SHOW_TOAST"] = 4] = "EFFECT_SHOW_TOAST";
    /** EFFECT_NAVIGATE_TO_URL - Notify the client to navigate to a URL */
    EffectType[EffectType["EFFECT_NAVIGATE_TO_URL"] = 5] = "EFFECT_NAVIGATE_TO_URL";
    /**
     * EFFECT_SET_INTERVALS - This updates the list of active timers.
     *
     * @deprecated
     */
    EffectType[EffectType["EFFECT_SET_INTERVALS"] = 7] = "EFFECT_SET_INTERVALS";
    /**
     * EFFECT_CREATE_ORDER - This starts a purchase flow
     *
     * @deprecated
     */
    EffectType[EffectType["EFFECT_CREATE_ORDER"] = 8] = "EFFECT_CREATE_ORDER";
    /**
     * EFFECT_WEB_VIEW - Control and communicate with WebViews
     *
     * @deprecated
     */
    EffectType[EffectType["EFFECT_WEB_VIEW"] = 9] = "EFFECT_WEB_VIEW";
    /**
     * EFFECT_CAN_RUN_AS_USER - Check if the app can execute some actions as the user
     *
     * @deprecated
     */
    EffectType[EffectType["EFFECT_CAN_RUN_AS_USER"] = 11] = "EFFECT_CAN_RUN_AS_USER";
    /**
     * EFFECT_TELEMETRY - Statistical data event for analytics.
     *
     * @deprecated
     */
    EffectType[EffectType["EFFECT_TELEMETRY"] = 12] = "EFFECT_TELEMETRY";
    /**
     * EFFECT_UPDATE_REQUEST_CONTEXT - Request an updated signed request context
     *
     * @deprecated
     */
    EffectType[EffectType["EFFECT_UPDATE_REQUEST_CONTEXT"] = 13] = "EFFECT_UPDATE_REQUEST_CONTEXT";
    /**
     * EFFECT_SCREENSHOT_RESPONSE - Send the screenshot response from web view to the client
     *
     * @deprecated
     */
    EffectType[EffectType["EFFECT_SCREENSHOT_RESPONSE"] = 14] = "EFFECT_SCREENSHOT_RESPONSE";
    /**
     * EFFECT_LOGIN_PROMPT - Request a login/signup prompt
     *
     * @deprecated
     */
    EffectType[EffectType["EFFECT_LOGIN_PROMPT"] = 15] = "EFFECT_LOGIN_PROMPT";
    EffectType[EffectType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(EffectType || (EffectType = {}));
